import _ from 'lodash';
import { getDispatch, getState } from 'reducers';
import { updateAppState } from 'models/subscriptions/reducer';
import { hasNetworkError } from 'models/subscriptions/selector';
import { REQUESTS } from './requests';
import { apiCallRouter, getToken } from 'utils/api';
import { getAclBaseURL, getApiBaseURL, isStagingApp } from 'utils/helpers';
import AxiosCall from 'utils/axiosCall';
require('axios-debug-log');
export let tokenSources = [];
// Only allow email override in local dev — prevents privilege escalation in production
const overrideEmail = window.location.origin.match(/localhost/) ? localStorage.getItem('overrideEmail') : null;

const config = {
	apiBaseURL: getApiBaseURL(),
	aclBaseURL: getAclBaseURL(),
};

export function getAPIData(url, obj) {
	return apiCall('GET', url, obj);
}
export function getAPIDataV2(service, url, obj) {
	return apiCallV2('GET', service, url, obj);
}

export function getAPIDataV3({ service, url, body, queryParams, pathParams }) {
	return newApiCallV2({ type: 'GET', service, url, body, queryParams, pathParams });
}

export function patchAPIDataV3({ service, url, body, queryParams, pathParams }) {
	return newApiCallV2({ type: 'PATCH', service, url, body, queryParams, pathParams });
}

export function deleteAPIDataV3({ service, url, body, queryParams, pathParams }) {
	return newApiCallV2({ type: 'DELETE', service, url, body, queryParams, pathParams });
}

export function postAPIDataV3({ service, url, body, queryParams, pathParams }) {
	return newApiCallV2({ type: 'POST', service, url, body, queryParams, pathParams });
}

export function putAPIDataV3({ service, url, body, queryParams, pathParams }) {
	return newApiCallV2({ type: 'PUT', service, url, body, queryParams, pathParams });
}

export async function cancelOngoingRequests() {
	await _.forEach(tokenSources, async (source) => {
		await source.cancel('CANCELLED');
	});
}

function appendPathParamsToUrl(url, pathParams) {
	if (!pathParams) return url;
	Object.keys(pathParams).forEach((key) => {
		url = url.replace(`{{${key}}}`, pathParams[key]);
	});
	return url;
}

function appendQueryParamsToUrl(url, queryParams) {
	if (!queryParams) return url;
	Object.keys(queryParams).forEach((key, index) => {
		if (index === 0) {
			url += `?${key}=${queryParams[key]}`;
		} else {
			url += `&${key}=${queryParams[key]}`;
		}
	});
	return url;
}

async function newApiCallV2({ type, service, url, body, queryParams, pathParams }) {
	let axiosData = {};
	const isNetworkError = hasNetworkError(getState());

	const dispatch = getDispatch();
	try {
		const {
			token,
			userData: { userEmail, grpId },
			error,
		} = await getToken();

		let userJson = {
			email: overrideEmail || userEmail,
			groupId: grpId,
		};
		let base64EncodedUserJson = window.btoa(JSON.stringify(userJson));
		let baseURL = config.apiBaseURL;

		url = appendPathParamsToUrl(url, _.omitBy(pathParams, _.isNil));
		url = appendQueryParamsToUrl(url, _.omitBy(queryParams, _.isNil));

		if (isStagingApp()) {
			baseURL = `${baseURL}/api/${service}/staging/${base64EncodedUserJson}/${url}`;
		} else {
			baseURL = `${baseURL}/api/${service}/${base64EncodedUserJson}/${url}`;
		}

		if (service === 'acl') {
			baseURL = `${config.aclBaseURL}/${base64EncodedUserJson}/${url}`;
		}

		axiosData.INSTANCE = new AxiosCall({
			baseURL,
			timeout: 300000,
		});
		if (!token) {
			throw new Error('Invalid Token');
		}
		axiosData.INSTANCE.setAuthorization(token);
	} catch (e) {
		if (e?.response?.status === 401) {
			dispatch(
				updateAppState({
					isLoggedOutUser: true,
				})
			);
		}
		return Promise.reject({});
	}
	return apiCallRouter(type, axiosData.INSTANCE, body).catch((error) => {
		if (error?.response?.status === 401) {
			dispatch(
				updateAppState({
					isLoggedOutUser: true,
				})
			);
			return Promise.reject({});
		}
		return Promise.reject(error.response || error);
	});
}

export async function selectTenent(email, partnerId, token) {
	const dispatch = getDispatch();
	let axiosData = {};
	try {
		let baseURL;

		if (isStagingApp()) {
			baseURL = `${config.apiBaseURL}/api/staging/tenant/selectcompany`;
		} else {
			baseURL = `${config.apiBaseURL}/api/tenant/selectcompany`;
		}

		axiosData.INSTANCE = new AxiosCall({
			baseURL,
			timeout: 60000,
		});
		if (!token) {
			throw new Error('Invalid Token');
		}

		axiosData.INSTANCE.setAuthorization(token);
	} catch (e) {
		dispatch(
			updateAppState({
				isLoggedOutUser: true,
			})
		);
		return;
	}
	return apiCallRouter('POST', axiosData.INSTANCE, { email, partnerId }).catch((error) => {
		if (error?.response?.status === 401) {
			dispatch(
				updateAppState({
					isLoggedOutUser: true,
				})
			);
			return Promise.reject({});
		}
		return Promise.reject(error.response || error);
	});
}

export async function getUserTenent(email, token) {
	const dispatch = getDispatch();
	let axiosData = {};
	try {
		let baseURL;

		if (isStagingApp()) {
			baseURL = `${config.apiBaseURL}/api/staging/tenant/Selectedcompany`;
		} else {
			baseURL = `${config.apiBaseURL}/api/tenant/Selectedcompany`;
		}

		axiosData.INSTANCE = new AxiosCall({
			baseURL,
			timeout: 60000,
		});
		if (!token) {
			throw new Error('Invalid Token');
		}

		axiosData.INSTANCE.setAuthorization(token);
	} catch (e) {
		dispatch(
			updateAppState({
				isLoggedOutUser: true,
			})
		);
		return;
	}
	return apiCallRouter('POST', axiosData.INSTANCE, { email }).catch((error) => {
		if (error?.response?.status === 401) {
			dispatch(
				updateAppState({
					isLoggedOutUser: true,
				})
			);
			return Promise.reject({});
		}
		return Promise.reject(error.response || error);
	});
}

async function apiCallAcl(type, service, url, obj) {
	let axiosData = {};
	const isNetworkError = hasNetworkError(getState());

	const dispatch = getDispatch();
	try {
		const {
			token,
			userData: { userEmail, grpId },
			error,
		} = await getToken();

		console.log('userData', error);

		let userJson = {
			email: overrideEmail || userEmail,
			groupId: grpId,
		};
		let base64EncodedUserJson = window.btoa(JSON.stringify(userJson));
		let baseURL = config.aclBaseURL;

		if (isStagingApp()) {
			baseURL = `${baseURL}/${base64EncodedUserJson}/${service}/${url}`;
		} else {
			baseURL = `${baseURL}/${base64EncodedUserJson}/${service}/${url}`;
		}

		axiosData.INSTANCE = new AxiosCall({
			baseURL,
			timeout: 60000,
		});
		if (!token) {
			throw new Error('Invalid Token');
		}
		axiosData.INSTANCE.setAuthorization(token);
	} catch (e) {
		console.log('error', e);
		dispatch(
			updateAppState({
				isLoggedOutUser: true,
			})
		);
		return Promise.reject({});
	}
	return apiCallRouter(type, axiosData.INSTANCE, obj).catch((error) => {
		if (error?.response?.status === 401) {
			dispatch(
				updateAppState({
					isLoggedOutUser: true,
				})
			);
			return Promise.reject({});
		}
		return Promise.reject(error.response || error);
	});
}

async function apiCallV2(type, service, url, obj) {
	let axiosData = {};
	const isNetworkError = hasNetworkError(getState());

	const dispatch = getDispatch();
	try {
		const {
			token,
			userData: { userEmail, grpId },
			error,
		} = await getToken();
		console.log(error);
		let userJson = {
			email: overrideEmail || userEmail,
			groupId: grpId,
		};
		let base64EncodedUserJson = window.btoa(JSON.stringify(userJson));
		let baseURL = config.apiBaseURL;

		if (isStagingApp()) {
			baseURL = `${baseURL}/api/${service}/staging/${base64EncodedUserJson}/${url}`;
		} else {
			baseURL = `${baseURL}/api/${service}/${base64EncodedUserJson}/${url}`;
		}

		axiosData.INSTANCE = new AxiosCall({
			baseURL,
			timeout: 60000,
		});
		if (!token) {
			throw new Error('Invalid Token');
		}
		axiosData.INSTANCE.setAuthorization(token);
	} catch (e) {
		dispatch(
			updateAppState({
				isLoggedOutUser: true,
			})
		);
		return Promise.reject({});
	}
	return apiCallRouter(type, axiosData.INSTANCE, obj).catch((error) => {
		if (error?.response?.status === 401) {
			dispatch(
				updateAppState({
					isLoggedOutUser: true,
				})
			);
			return Promise.reject({});
		}
		return Promise.reject(error.response || error);
	});
}

async function apiCall(type, url, obj) {
	const dispatch = getDispatch();
	let axiosData = {};
	const isNetworkError = hasNetworkError(getState());

	try {
		const {
			token,
			userData: { userEmail, grpId },
			error,
		} = await getToken();
		let userJson = {
			email: overrideEmail || userEmail,
			groupId: grpId,
		};
		let base64EncodedUserJson = window.btoa(JSON.stringify(userJson));
		let baseURL;

		if (isStagingApp()) {
			baseURL = `${config.apiBaseURL}/api/staging/${url}`;
		} else {
			baseURL = `${config.apiBaseURL}/api/${url}`;
		}

		axiosData.INSTANCE = new AxiosCall({
			baseURL,
			timeout: 60000,
		});
		if (!token) {
			throw new Error('Invalid Token');
		}

		axiosData.INSTANCE.setAuthorization(token, base64EncodedUserJson);
	} catch (e) {
		dispatch(
			updateAppState({
				isLoggedOutUser: true,
			})
		);
		return Promise.reject({});
	}
	return apiCallRouter(type, axiosData.INSTANCE, obj).catch((error) => {
		if (error?.response?.status === 401) {
			dispatch(
				updateAppState({
					isLoggedOutUser: true,
				})
			);
			return Promise.reject({});
		}
		return Promise.reject(error.response || error);
	});
}

export function postAPIData(url, obj) {
	return apiCall('POST', url, obj);
}

export function getAPIDataAcl(url, service, obj) {
	return apiCallAcl('GET', url, service, obj);
}

export function putAPIData(url, obj) {
	return apiCall('PUT', url, obj);
}

export function putAPIDataV2(service, url, obj) {
	return apiCallV2('PUT', service, url, obj);
}

export function postAPIDataV2(service, url, obj, options) {
	return apiCallV2('POST', service, url, obj, options);
}

export function patchAPIDataV2(service, url, obj) {
	return apiCallV2('PATCH', service, url, obj);
}

export function deleteAPIData(url, obj) {
	return apiCall('DELETE', url, obj);
}

export function deleteAPIDataV2(service, url, obj) {
	return apiCallV2('DELETE', service, url, obj);
}

export function getUserSettingsData() {
	return getAPIDataV3(REQUESTS.GET.GET_USER_CONFIG)
		.then((response) => ({ response: response?.data }))
		.catch((error) => ({ error, isError: true }));
}

export function getAccessControlOperations() {
	return getAPIDataV3(REQUESTS.GET.GET_USER_CONFIG)
		.then((response) => ({ response: response?.data }))
		.catch((error) => ({ error, isError: true }));
}

export const checkPollingStatus = async (statusId) => {
	if (statusId) {
		try {
			const response = await getAPIDataV3({
				...REQUESTS.GET.GET_PROCESS_STATUS,
				pathParams: { statusId },
				queryParams: { refresh: new Date().getTime().toString() },
			});

			return { status: response?.data.ResultSets?.Table1[0].CurrentStatus };
		} catch (error) {
			console.error('No StatusID received.', error);
			return { success: false, isError: true };
		}
	} else {
		return { success: false, isError: true };
	}
};

export const checkPollingStatusV2 = async (statusId) => {
	if (statusId) {
		try {
			const response = await getAPIDataV3({
				service: REQUESTS.GET.GET_PROCESS_STATUS.service,
				url: REQUESTS.GET.GET_PROCESS_STATUS.url,
				pathParams: { statusId },
				queryParams: { refresh: new Date().getTime().toString() },
			});
			return { status: response?.data.data.CurrentStatus };
		} catch (error) {
			console.error('No StatusID received.', error);
			return { success: false, isError: true };
		}
	} else {
		return { success: false, isError: true };
	}
};

export { REQUESTS };
